export var ConnectedWallet = 'connectedWallet';
export var PORTKEY_ORIGIN_CHAIN_ID_KEY = 'PortkeyOriginChainId';
export var PORTKEYAA = 'PortkeyAA';
export var PORTKEY_DISCOVER = 'PortkeyDiscover';
export var DEFAULT_PIN = '111111';